<span
  class='indicator-dot-container'
  [ngClass]="{
    'indicator-dot-success': isIndicatorSuccess,
    'indicator-dot-error': !isIndicatorSuccess,
  }"
>
</span>
